export const generateAutomationsFieldName = (compId, fieldName) => {
    return `${compId}.${fieldName}`;
};
//# sourceMappingURL=generateFieldName.js.map